
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fcwrtmchfcwzdvlkhwat.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZjd3J0bWNoZmN3emR2bGtod2F0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5ODMxNzEsImV4cCI6MjA1NTU1OTE3MX0.ZSMukI7PM4uue9RswmEA7IJGYtHR7vVKHJ5rb5spEhI";

// Get the site URL for redirects and email links
export const SITE_URL = typeof window !== 'undefined' 
  ? window.location.origin
  : 'http://scheduler.disturbedmedia.co.uk';

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    }
  }
);
